import { css } from "@emotion/css";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ExternalLink from "~/components/Navigation/ExternalLink/index";
const topicsStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: space[12],
    color: themeTokens.color.text.secondary,
    marginTop: space[12],
});
const overviewStyles = css({
    marginTop: space[12],
    marginBottom: space[12],
});
export const CommonComplianceOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <div className={overviewStyles}>
                    <ExternalLink href="policies">Policies</ExternalLink> ensure compliance and governance by default. Enforce pre- and post-deployment controls at scale.
                </div>
                <div className={overviewStyles}>Policies are stored in Git, and connected to your Octopus instance. They can be scoped to any environment and enforce actions on deployment processes not matching the policy criteria.</div>
            </OverviewHighlightText>
        </OverviewContainer>);
};
export const CommonComplianceTopics = () => {
    return (<TopicsContainer>
            <LearnMoreResources title="Getting started guides">
                <div className={topicsStyles}>
                    <ExternalLink href="policies">Setting up a policy</ExternalLink>
                    <ExternalLink href="policy-examples">Policy Examples</ExternalLink>
                    <ExternalLink href="policies-best-practices">Policies Best Practices</ExternalLink>
                </div>
            </LearnMoreResources>
        </TopicsContainer>);
};
